import { Coffee, Sun, Moon, Apple } from 'lucide-react';

// Meal type icons and colors
export const MEAL_TYPE_CONFIG = {
  breakfast: { icon: Coffee, color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Breakfast' },
  lunch: { icon: Sun, color: 'text-yellow-400', bg: 'bg-yellow-500/20', label: 'Lunch' },
  dinner: { icon: Moon, color: 'text-blue-400', bg: 'bg-blue-500/20', label: 'Dinner' },
  snack: { icon: Apple, color: 'text-green-400', bg: 'bg-green-500/20', label: 'Snack' }
};

// Goal labels and colors
export const GOAL_CONFIG = {
  weight_loss: { label: 'Weight Loss', color: 'text-red-400', bg: 'bg-red-500/20' },
  muscle_building: { label: 'Muscle Building', color: 'text-blue-400', bg: 'bg-blue-500/20' },
  endurance: { label: 'Endurance', color: 'text-green-400', bg: 'bg-green-500/20' },
  general_fitness: { label: 'General Fitness', color: 'text-purple-400', bg: 'bg-purple-500/20' },
  maintenance: { label: 'Maintenance', color: 'text-gray-400', bg: 'bg-gray-500/20' }
};
